import { gql } from "lib/apolloClient";
import { curriculumProgramFragment } from "modules/CommonFragments";

export const singleCourseV2Fragment = gql`
  fragment singleCourseV2 on Course {
    id
    title
    curriculumProgram {
      ...curriculumProgramBasicDetailsItem
    }
    profileImageData {
      url
      icon
    }
    subjects {
      id
      type
      subjectGroup {
        id
      }
    }
    subjectGroups {
      id
      type
    }
    grades {
      id
      displaySequence
    }
    learningCourse {
      id
    }
  }
`;
export const userCoursesPageFragment = gql`
  fragment staffCourses on Staff {
    id
    coursesV2(orderBy: TITLE, orderByDirection: ASC, filters: $courseFilters) {
      edges {
        node {
          ...singleCourseV2
        }
      }
    }
  }
  ${singleCourseV2Fragment}
  ${curriculumProgramFragment.curriculumProgramBasicDetails}
`;
